<script>
import { mapState, mapActions } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';
import { useFeedStore } from '../../../store/useFeedStore.js';
import { setUserProfile } from '../api/users';

export default {
  name: 'CpMissingInfoForm',
  components: {
    CpButton: require('../button').default,
    CpDialog: require('../dialog').default,
    CpBoxContent: require('../box-content').default,
    CpBox: require('../box').default,
    VueSimpleSpinner: require('../vue-simple-spinner').default,
    CpTextInput: require('../inputs/text').default,
    CpSelect: require('../select').default,
    validateZip: require('../mixins/utils').default,
    validateInput: require('../mixins/utils').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginRight: require('../directives/margins').marginRight,
    marginBottom: require('../directives/margins').marginBottom,
    marginLeft: require('../directives/margins').marginLeft,
  },
  props: {
    handleDialog: Function,
  },
  data() {
    return {
      state: '',
      postalCode: '',
      stateError: '',
      zipError: '',
      loading: false,
    };
  },
  computed: {
    ...mapState(useUserStore, ['isUserLogin', 'userProfileData']),
    ...mapState(useFeedStore, ['usStates']),
    hasInputError() {
      const hasValidationErrors = !!this.zipError || !!this.stateError;
      const hasMissingRequiredFields = !this.state || !this.postalCode;
      return hasValidationErrors || hasMissingRequiredFields;
    },
  },
  mounted() {
    if (!this.usStates.length) {
      this.getStatesFromStore();
    }
  },
  methods: {
    redirectTo(path) {
      window.location.href = path;
    },
    handleSubmit() {
      this.loading = true;
      setUserProfile({
        address_state: this.state,
        address_zip: this.postalCode,
      }).then(() => {
        this.getUserProfile().then(() => {
          this.$emit('address-updated');
        });
      });
    },
    ...mapActions(useFeedStore, ['getStatesFromStore']),
    ...mapActions(useUserStore, ['getUserProfile']),
  },
  watch: {
    postalCode() {
      this.zipError = this.validateZip(this.postalCode);
    },
    state() {
      this.stateError = this.validateInput(this.state);
    },
  },
};
</script>

<template>
  <CpDialog :isNested="true">
    <CpBox>
      <CpBoxContent>
        <div class="missingInfoContainer">
          <h4 class="subhead neutral-2-color">Before you contact your lawmaker, we need to know your address</h4>
          <div v-if="!isUserLogin">
            <cp-button thin noborder @click="redirectTo('/user/login')">Enter your address to see your Representatives</cp-button>
          </div>
          <div v-else v-margin="1.5">
            <div v-if="!userProfileData.address_state" v-margin-bottom="0.5">
              <label class="subhead neutral-2-color">
                State <span class="caption primary-color">(Required)</span>
                <CpSelect block v-model="state">
                  <option value="">- Select State -</option>
                  <option v-for="(stateName, stateAbbrev) in usStates" :value="stateAbbrev">{{ stateName }}</option>
                </CpSelect>
              </label>
              <p v-if="stateError" class="caption error-color">{{ stateError }}</p>
            </div>
            <div v-if="!userProfileData.address_zip" v-margin-bottom="0.5">
              <label class="subhead neutral-2-color">
                Postal code <span class="caption primary-color">(Required)</span>
                <CpTextInput block v-model="postalCode" placeholder="Postal code" />
              </label>
              <p v-if="zipError" class="caption error-color">{{ zipError }}</p>
            </div>
          </div>
          <div class="box-buttons">
            <CpButton @click="handleDialog" class="btn-lobby" block>CANCEL</CpButton>
            <CpButton @click="handleSubmit" class="btn-lobby" block primary :loading="loading" :disabled="loading || hasInputError">SEND</CpButton>
          </div>
        </div>
      </CpBoxContent>
    </CpBox>
  </CpDialog>
</template>

<style scoped>
.missingInfoContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.btn-lobby {
  margin: 5px;
}
.box-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
@media only screen and (max-width: 768px) {
  .btn-lobby {
    width: 50%;
  }
}
</style>
